const Roles = Object.freeze({
  ClinicUser: "clinic_user",
  SiteAdmin: "site_admin",
  DistributorAdmin: "distributor_admin",
  SupportAgent: "support_agent",
} as const);

export type Roles = (typeof Roles)[keyof typeof Roles];

export const RoleLabels = Object.freeze({
  [Roles.ClinicUser]: "Clinic User",
  [Roles.SiteAdmin]: "Site Admin",
  [Roles.DistributorAdmin]: "Distributor Admin",
  [Roles.SupportAgent]: "Support Agent",
});

export default Roles;
